function getUrlParam(name: string) {
  return new URLSearchParams(window.location.search).get(name);
}

export function getCallbackUrl() {
  return getUrlParam("callback");
}

export function redirectToCallbackUrl() {
  var url = getCallbackUrl();

  if (url) {
    redirect(url);
  } else if (process.env.REACT_APP_DEFAULT_REDIRECT) {
    redirect(process.env.REACT_APP_DEFAULT_REDIRECT);
  }
}

export function redirect(url: string) {
  window.location.href = url;
}

const SIGNUP_URL_PROD = "https://signup.segfy.com";
const SIGNUP_URL_BETA = "https://sellerfy.segfybeta.com";

// URL de cadastro ("Assine agora"). Só o ambiente de QA/staging usa o segfybeta;
// prod (e qualquer outro ambiente) mantém o link de produção por padrão.
export function getSignupUrl() {
  const env = process.env.REACT_APP_SEGFY_ENVIRONMENT;
  const betaEnvs = ["qa", "staging"];

  if (env && betaEnvs.includes(env)) {
    return SIGNUP_URL_BETA;
  }

  return SIGNUP_URL_PROD;
}
